import "../styles/Recommendations.css"

function HomemadeAlternative({ alternatives }) {
  return (
    <div className="homemade-section">
      <h2 className="section-title">🍲 Homemade Alternatives:</h2>
      <div className="homemade-content">
        {Array.isArray(alternatives) ? (
          <ul className="homemade-list">
            {alternatives.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ) : (
          <p>{alternatives}</p>
        )}
      </div>
    </div>
  )
}

export default HomemadeAlternative

